import { render, staticRenderFns } from "./ActionItem.vue?vue&type=template&id=6bc30ca4&lang=pug"
import script from "./ActionItem.vue?vue&type=script&lang=ts"
export * from "./ActionItem.vue?vue&type=script&lang=ts"
import style0 from "./ActionItem.vue?vue&type=style&index=0&id=6bc30ca4&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports